import { LazyLoad } from 'app/utils';

export const BannerFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.BannerFormPage,
);
